import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  timeout: 20000
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('rp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 || err.response?.status === 403) {
      localStorage.removeItem('rp_token');
      localStorage.removeItem('rp_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;

// Helper: convert filters object to query params (skip 'all' and empty values)
function clean(filters = {}) {
  return Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v && v !== 'all')
  );
}

// Auth
export const login       = (u, p)  => API.post('/auth/login',  { username: u, password: p });
export const verifyToken = (token) => API.post('/auth/verify', { token });

// Filters (dynamic options from DB)
export const getFilterOptions = (params) => API.get('/filters/options', { params });

// Dashboard — all accept a filters object
export const getOverview          = (f) => API.get('/dashboard/overview',              { params: clean(f) });
export const getEnrolmentByRegion = (f) => API.get('/dashboard/enrolment/by-region',  { params: clean(f) });
export const getEnrolmentByFacility=(f) => API.get('/dashboard/enrolment/by-facility',{ params: clean(f) });
export const getMonthlyEnrolment  = (f) => API.get('/dashboard/enrolment/monthly',    { params: clean(f) });
export const getDiseases          = (f) => API.get('/dashboard/diseases',              { params: clean(f) });
export const getMonthlyMessages   = (f) => API.get('/dashboard/messages/monthly',     { params: clean(f) });
export const getTelecomStats      = (f) => API.get('/dashboard/messages/telecom',     { params: clean(f) });
export const getEngagement        = (f) => API.get('/dashboard/engagement',           { params: clean(f) });
export const getNonResponders     = (f, page, limit) =>
  API.get('/dashboard/non-responders', { params: { ...clean(f), page, limit } });
export const getSMSReport    = (dateFrom, dateTo) => API.get(`/dashboard/report/sms-usage`, { params: { dateFrom, dateTo } });
export const getFailedMessages = (filters = {}) => API.get('/dashboard/messages/failed', { params: filters });
export const getPackageReport = (dateFrom, dateTo) => API.get('/dashboard/report/package-consumption', { params: { dateFrom, dateTo } });
export const getImmunEnrollments = (filters = {}) => API.get('/dashboard/immunization/enrollments', { params: filters });
export const getImmunAttendance  = (filters = {}) => API.get('/dashboard/immunization/attendance',  { params: filters });
export const getImmunMissed      = (filters = {}) => API.get('/dashboard/immunization/missed',       { params: filters });
export const getImmunHotspot     = (filters = {}) => API.get('/dashboard/immunization/hotspot',      { params: filters });
export const getImmunFilters     = ()              => API.get('/dashboard/immunization/filters');
